import Select, { components } from "react-select";
import classNames from "classnames";
import { Icon } from "assets/icons";
import { forwardRef } from "react";
import {
  ActionMeta,
  OnChangeValue,
} from "react-select/dist/declarations/src/types";

import { MediumText } from "components/MediumText/MediumText";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";

import styles from "./styles.module.scss";

export type Option = {
  value: string;
  label: string;
};

export type AppSelectProps = {
  label?: string;
  options: Option[];
  value?: Option | null;
  isDisabled?: boolean;
  isSearchable?: boolean;
  isClearable?: boolean;
  isLoading?: boolean;
  isMulti?: boolean;
  className?: string;
  placeholder?: string;
  onChange?: (option: Option | string | null) => void;
  onInputChange?: (value: string) => void;
  filterOption?: any;
};

const customStyles = {
  dropdownIndicator: (provided: any) => ({
    ...provided,
    color: "black",
    fontSize: 8,
  }),
  option: (provided: any) => ({
    ...provided,
    color: "black",
    fontSize: 14,
    fontFamily: "RubikRegular",
  }),
  control: (provided: any) => ({
    ...provided,
    color: "black",
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: "black",
    fontSize: 14,
    fontFamily: "RubikRegular",
  }),
  input: (provided: any) => ({
    ...provided,
    fontSize: 14,
  }),
};

export const AppSelect = forwardRef<HTMLDivElement, AppSelectProps>(
  (props: AppSelectProps, ref): JSX.Element => {
    const {
      label,
      options,
      value,
      isDisabled,
      isSearchable,
      isClearable,
      isLoading,
      isMulti,
      className,
      placeholder,
      onChange,
      onInputChange,
      filterOption,
    } = props;

    return (
      <div
        ref={ref}
        className={`flex items-center text-nowrap justify-between ${className}`}
      >
        <MediumText>{label}</MediumText>
        <HorizontalSpace size={5} />
        <Select
          placeholder={placeholder}
          className={classNames(styles.select, className, "text-xs")}
          classNamePrefix="select"
          value={value}
          isDisabled={isDisabled}
          isLoading={isLoading}
          isClearable={isClearable}
          isSearchable={isSearchable}
          isMulti={isMulti}
          styles={customStyles}
          components={{
            IndicatorSeparator: () => null,
            CrossIcon: () => <Icon type="close" />,
            DropdownIndicator: isDisabled
              ? () => null
              : components.DropdownIndicator,
          }}
          name="color"
          options={options}
          onInputChange={(val) => onInputChange?.(val)}
          filterOption={filterOption}
          onChange={
            onChange as (
              newValue: OnChangeValue<Option, boolean>,
              actionMeta: ActionMeta<Option>
            ) => void
          }
        />
      </div>
    );
  }
);
